// Used in the Collection and Search templates
if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();

      // Get the template & section to grab the content from on fetch
      this.currentTemplate = 'collection';
      this.ajaxSectionToLoad = 'collection-products-content';

      if (document.body.classList.contains('template-search')) {
        this.currentTemplate = 'search';
        this.ajaxSectionToLoad = 'search-products-content';
      } else if (document.body.classList.contains('template-blog')) {
        this.currentTemplate = 'blog';
        this.ajaxSectionToLoad = 'blog-artists-content';
      }

      this.currentPageValue = +this.querySelector('[data-current-page]').value;

      // update the array of loaded pages
      this.loadedPages = [];
      if (this.loadedPages.indexOf(this.currentPageValue) === -1)
        this.loadedPages.push(this.currentPageValue);

      this.initLoadMoreButtons();
    }

    /**
     * initLoadMoreButtons
     * @description Create the load more/prev buttons. It's also called again after fetch is done
     */
    initLoadMoreButtons() {
      // hide the buttons based on the page displayed
      this.currentPageValue === 1 && this.querySelector('[data-load-trigger="prev"]') != null
        ? this.querySelector('[data-load-trigger="prev"]').classList.add('hidden')
        : null;

      this.loadTrigger = this.querySelectorAll('[data-load-trigger]');
      this.loadTrigger.forEach((trigger) =>
        trigger.addEventListener('click', this.loadItems.bind(this))
      );
    }

    /**
     * loadItems
     * @description Gets the url to fetch and toggles the load items/loading text
     * @param {Object} event
     */
    loadItems(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const linkElement = event.target.closest('a');
      const direction = linkElement.dataset.loadTrigger;
      linkElement.querySelector('[data-load-text]').classList.add('hidden');
      linkElement.querySelector('[data-loader]').classList.remove('hidden');

      const url = `${linkElement.href}&section_id=${this.ajaxSectionToLoad}`;
      this.renderElementsFromFetch(url, linkElement.href, direction);
    }

    /**
     * renderElementsFromFetch
     * @description Renders the products/articles based on the fetch url data.
     * @param {String} url
     * @param {String} page
     * @param {String} direction
     */
    renderElementsFromFetch(url, page, direction) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          let wrapperID = this.currentTemplate === 'blog' ? '#articles' : '#products';

          if (!html.querySelector(`${wrapperID}`)) return;

          let elementsWrapper = document.querySelector('#CollectionProductGrid');
          let wrapperIDSelector = '[data-products-list]';

          if (this.currentTemplate === 'search') {
            elementsWrapper = document.querySelector('#SearchProductGrid');
          } else if (this.currentTemplate === 'blog') {
            elementsWrapper = document.querySelector('#ArtistBlogGrid');
            wrapperIDSelector = '[data-articles-list]';
          }

          // update the wrapper with the new elements (products)
          const newContent = html.querySelector(`${wrapperID} ${wrapperIDSelector}`).innerHTML;
          const newElement = document.createRange().createContextualFragment(newContent);

          // depending on the direction of the click, append or prepend the products and update the pagination
          if (direction == 'next') {
            elementsWrapper.querySelector(`${wrapperIDSelector}`).append(newElement);
            // update the pagination
            const paginationNextHtml = html.querySelector('[data-pagination-next]').innerHTML;
            elementsWrapper.querySelector('[data-pagination-next]').innerHTML = paginationNextHtml;
          } else {
            elementsWrapper.querySelector(`${wrapperIDSelector}`).prepend(newElement);
            // update the pagination
            const paginationPrevHtml = html.querySelector('[data-pagination-prev]').innerHTML;
            elementsWrapper.querySelector('[data-pagination-prev]').innerHTML = paginationPrevHtml;
          }

          // update the variables because the returned amount of products will likely have different pagination values
          this.currentPageValue = +html.querySelector('[data-current-page]').value;

          // update the array of loaded pages
          if (this.loadedPages.indexOf(this.currentPageValue) === -1)
            this.loadedPages.push(this.currentPageValue);

          // reload the function since variables might have changed
          this.initLoadMoreButtons(true);

          // update the frames preview after changing pagination
          this.productOverviewFramePreview = document.querySelector(
            'product-overview-frame-preview'
          );
          if (this.productOverviewFramePreview) {
            this.productOverviewFramePreview.updateProductCardsWithSelectedFrame();

            // update the Match artwork promo options that were replaced after pagination
            this.productOverviewFramePreview.updateMatchArtworkPromoSwitches();
          }

          // update url
          this.updateURLHash(page);

          // update the hidden input with the new value
          this.querySelector('[data-current-page]').value = page.split('page=')[1];
        });
    }

    /**
     * updateURLHash
     * @param {String} url
     */
    updateURLHash(url) {
      history.pushState('', '', url);
    }
  }
  customElements.define('load-more', LoadMore);
}
